/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type expenseRow_company = {
    readonly id: string;
    readonly expenseCategories: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly disabled: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "expenseRow_company";
};
export type expenseRow_company$data = expenseRow_company;
export type expenseRow_company$key = {
    readonly " $data"?: expenseRow_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"expenseRow_company">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "expenseRow_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "ExpenseCategoryTypeConnection",
      "kind": "LinkedField",
      "name": "expenseCategories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseCategoryTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "disabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "expenseCategories(first:10000)"
    }
  ],
  "type": "Company"
};
})();
(node as any).hash = '035d44d4a3bd2080a6ab3cab99bef78d';
export default node;
